import React, { useContext, useState } from 'react'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import { Checkbox, FormHelperText, Grid, TextField, withStyles } from '@material-ui/core'
import { FirebaseService, FirebaseConfigKey } from '../../services/FirebaseService'
import FlexView from 'react-flexview/lib'
import { liabilityLimitPretty } from '../../services/utils'
import { useForm } from 'react-hook-form'
import { SkywatchDialog } from './SkywatchDialog'
import AssignmentIcon from '@material-ui/icons/Assignment'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import { ControlledSignature } from '../Core/Input/ControlledSignature'
import { SessionContextStore } from '../../context/SessionContext'
import { BuyingInsuranceContextStore } from '../../context/BuyingInsuranceContext'
import NewFillButton from '../Core/NewFillButton'
import { ScrollableText } from '../Core/ScrollableText.js'
import '../Core/ScrollableText.scss'
import ReactHtmlParser from 'react-html-parser'
import { ContinueButton } from '../Core/Buttons/ContinueButton'
import './SignRequiredPopup.scss'
import { isMobile } from 'react-device-detect'
import { TextButton } from '../Core/Buttons/TextButton'
import { reportGTM } from '../Core/Utilities/GTagManger'

const NewDialog = withStyles({
  root: {
    zIndex: '100000000 !important',
  },
})(SkywatchDialog)

export const SignRequiredPopup = ({ onSignComplete, pdfs }) => {
  const [open, setOpen] = React.useState(false)
  const [reachedBottom, setReachedBottom] = React.useState(false)
  const sessionContext = React.useContext(SessionContextStore)
  const [numPages, setNumPages] = useState(null)
  const [pageNumber, setPageNumber] = useState(1)
  const [signAgree, setSignAgree] = React.useState(false)
  const offersContext = React.useContext(BuyingInsuranceContextStore)

  const { register, getValues, errors, trigger, triggerValidation, setValue, control } = useForm({ mode: 'onChange' })

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages)
  }

  const handleClickOpen = () => {
    if (offersContext.userSignatureRequiredForBrokerPurchase()) {
      reportGTM('', '', { event: 'select_reject_popup' })
    }
    setOpen(true)
  }

  const handleDisagree = () => {
    setOpen(false)
  }

  const handleAgree = async () => {
    let valid = await triggerValidation()

    if (!valid) return

    setOpen(false)

    onSignComplete && onSignComplete(getValues())
  }

  const showSignaturePopup = () => {
    setSignAgree(true)
  }

  const continueWithoutSignature = async () => {
    setOpen(false)
    if (offersContext.userSignatureRequiredForBrokerPurchase()) {
      reportGTM('', '', { event: 'select_reject_send_to_customer' })
    }

    onSignComplete && onSignComplete(getValues())
  }

  const onScrollBottom = () => {
    setReachedBottom(true)
  }

  const replaceFileNameOnMobile = (fileName, html) => {
    let imgUrl = `<img height="200" width="900" src="http://voom-motorcycle-prod.s3.amazonaws.com/Markel-Docs-Titles/${fileName}-markel-header.png" alt="logo"/>` //TODO: replance to filename!
    let imgUrlMobileVersion = `<img width="100%" src="http://voom-motorcycle-prod.s3.amazonaws.com/Markel-Docs-Titles/${fileName}-markel-header-mobile-version.jpg" alt="logo"/>` //TODO: replance to filename!
    let origReadCarefulyLine = '<div><span style="margin-left:300px"><b><u>READ CAREFULLY</u></b></span></div>'
    let readCarefulyLine = '<div><span style="margin-left:100px"><b><u>READ CAREFULLY</u></b></span></div>'
    return html.replace(imgUrl, imgUrlMobileVersion).replace(origReadCarefulyLine, readCarefulyLine)
  }

  React.useEffect(() => {
    register('signature', { required: true })

    let id = EventEmitterService.subscribe(EventKey.SIGN_REQUIERED_POPUP, () => {
      handleClickOpen()
    })

    return function cleanup() {
      EventEmitterService.unsubscribe(EventKey.SIGN_REQUIERED_POPUP, id)
    }
  }, [])

  return (
    <>
      <Dialog open={open} onClose={handleDisagree} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title">Signature required</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {'The coverages you selected require your signature on a form according to your state law.'}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDisagree} color="primary">
            Change your coverages
          </Button>
          {offersContext.userSignatureRequiredForBrokerPurchase() ? (
            <Button onClick={continueWithoutSignature} color="primary" autoFocus>
              Send to customer for signature
            </Button>
          ) : (
            <Button onClick={showSignaturePopup} color="primary" autoFocus>
              Continue to form
            </Button>
          )}
        </DialogActions>
      </Dialog>
      {signAgree && (
        <NewDialog
          id="markel-form"
          open={open}
          shouldScroll={false}
          closeDialog={handleDisagree}
          circleHeader={
            <ElevatedCircle>
              <AssignmentIcon className="blue" />
            </ElevatedCircle>
          }
          closeTitle={'Coverages Confirmation'}
          shouldHaveHeight
          maxWidth={'md'}
        >
          <div className="signature-pop-up">
            <div className="text-title blue bold">
              *Please carefully review the form provided and proceed to sign below. Please note that we have already selected the
              appropriate options based on your chosen coverages.
            </div>
            <div className="dialog-content">
              {!isMobile && pdfs && (
                <div className="white-background content-scrollable">
                  {Object.entries(pdfs).map(x => (
                    <div id="embedded-html">
                      {ReactHtmlParser(x[1].output.replace('<img height="200" width="900"', '<img height="100%" width="100%"'))}
                    </div>
                  ))}
                </div>
              )}

              {isMobile && pdfs && (
                <div className="white-background content-scrollable">
                  {Object.entries(pdfs).map(x => (
                    <div id="embedded-html">{ReactHtmlParser(replaceFileNameOnMobile(x[0], x[1].output))}</div>
                  ))}
                </div>
              )}
            </div>
          </div>
          <FlexView
            wrap
            vAlignContent={'center'}
            hAlignContent={'center'}
            style={{ marginLeft: isMobile && '30px', margin: '25px 0' }}
            className="click-to-sign-div"
          >
            <ControlledSignature control={control} errors={errors} getValues={getValues} setValue={setValue} />
            <br />

            <TextButton
              onClick={handleAgree}
              text="Complete"
              withBorder
              className={'markel-submit-btn quote-button-size margin-bottom-small margin-top-small'}
            />
          </FlexView>
        </NewDialog>
      )}
    </>
  )
}
